export interface CubeRequestConfig {
  token: string;
}
